<template>
	<div class="container">
		<div class="row">
			<div class="col-sm-4">
				<div class="card card-wrapper">
					<img class="card-img-top" src="https://i.ibb.co/d0Ffkphk/20250820-102406.jpg" alt=""/>
					<div class="card-body">
						<h5 class="card-title">Nega tela</h5>
						<div class="card-text">
							<p>Naši ručno rađeni sapuni i kreme za telo su napravljeni od prirodnih sastojaka, sa maceratima (uljima) koje sama pravim od biljaka iz moje bašte ispod Vršačkih planina.</p>
						</div>
						<div class="button-wrapper">
							<router-link to="/shop/body">
								<button>Poručite</button>
							</router-link>
						</div>
					</div>
				</div>
			</div>
			<div class="col-sm-4">
				<div class="card card-wrapper">
					<img class="card-img-top" src="https://i.ibb.co/358CVhN8/20250820-111447.jpg" alt=""/>
					<div class="card-body">
						<h5 class="card-title">Nega lica</h5>
						<div class="card-text">
							<p>Nezi lica sam posvetila posebnu pažnju. Svi proizvodi se rade u malim serijama da bi za vas uvek bili sveži. Svi proizvodi za negu lica su veganski.</p>
						</div>
						<div class="button-wrapper">
							<router-link to="/shop/face">
								<button>Poručite</button>
							</router-link>
						</div>
					</div>
				</div>
			</div>
			<div class="col-sm-4">
				<div class="card card-wrapper">
					<img class="card-img-top" src="https://i.ibb.co/RTSj5gK/20221117-204203.jpg" alt=""/>
					<div class="card-body">
						<h5 class="card-title">Poklon kutije</h5>
						<div class="card-text">
							<p>Radim sa puno ljubavi. Možete odabrati sebi i Vama dragoj osobi idealan poklon. Na kraju svi volimo poklone, zar ne?</p>
						</div>
						<div class="button-wrapper">
							<router-link to="/shop/giftbox">
								<button>Poručite</button>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "HomeCards"
}
</script>

<style scoped>
	.container {
		padding-bottom: 100px;
	}

	.col-sm-4 {
		padding: 15px;
	}

	.card-wrapper {
		cursor: pointer;
		background: #fbfafb;
	}

	button:hover {
		box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
	}

	.card-text {
		display: flex;
		height: 120px;
	}

	button {
		background: transparent;
		color: #1A1A1A;
		font-size: 16px;
		width: 150px;
		padding: 10px;
		border: 1px solid #1A1A1A;
		border-radius: 40px;
		cursor: pointer;
	}

	.button-wrapper {
		margin-top: 15px;
		display: flex;
		width: 100%;
		justify-content: center;
		align-items: center;
	}

    @media only screen and (max-width: 600px) {
        .card-text {
            height: 80px;
        }
    }

    @media only screen and (max-width: 1000px) {
        .card-text {
            display: flex;
            height: 220px;
        }
    }
</style>
